import Vue from "vue";
import VueRouter from "vue-router";
// 告诉 Vue 使用 Vue Router
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// 定义路由配置
const routes = [];

// 创建路由实例
const router = new VueRouter({
  mode: "history", // 使用 HTML5 History API
  //   base: process.env.BASE_URL,
  routes,
});

export default router;
